<template>
    <div id="online-env" v-wechat-title="$route.meta.title">
        <div :id="item.key" :class="['online', item.key === 'online' ? 'online-bg' : 'env-bg']" v-for="item in dataList" :key="item.key">
            <div class="online-container">
                <h1 class="title">{{ item.name }}</h1>
                <ul class="tag">
                    <li :class="[item.key === 'online' ? 'li-online' : 'li-env']" v-for="(tag, index) in item.tags" :key="index">{{tag}}</li>
                </ul>
                <p class="fit"><span class="icon-chengyuan"></span>{{item.applicable}}</p>
                <p class="message" v-html="item.desc"></p>
                <div :class="['process', item.key === 'online' ? 'process-online' : 'process-env']">
                    <template v-for="step in item.process">
                        <div :class="['step', step.url ? 'hasUrl' : '']" :key="step.step" @click="handleApply(step)">
                            <div class="step-count">{{step.step}}</div>
                            <span class="step-name">{{ step.name }}</span>
                        </div>
                        <svg v-if="step.hasNext" fill="#C4C6CC" style="width: 20px; height: 20px;" aria-hidden="true">
                            <use xlink:href="#icon-youjiantou"></use>
                        </svg>
                    </template>
                </div>
                <div class="operate">
                    <div :class="['btn', btn.name === '立即体验' ? 'online-btn' : 'online-env']" v-for="(btn, index) in item.btns" :key="index" @click="handleApply(btn)">{{ btn.name }}</div>
                </div>
                <div class="video" v-if="!Array.isArray(item.videoList)">
                    <div class="shade" v-if="isplay">
                        <p>线上环境动画演示</p>
                        <div class="identify">BlueKing</div>
                        <img src="../../images/online_env/bg.png" alt="">
                        <span class="tip2">最新功能抢先看，手把手教程</span>
                        <div class="play" @click="handlePlay"><span class="icon-player" style="font-size: 32px; padding: 0 15px 0 0px; vertical-align: middle;"></span>立即观看</div>
                        <div class="play-desc"></div>
                        <div class="f-shade">
                            <span class="icon-player" style="font-size: 32px; vertical-align: middle;"></span>
                            {{ item.videoList.desc || '线上环境动画演示' }}
                        </div>
                        <div class="f-shade-desc"></div>
                    </div>
                    <video v-else id="video" style="width: 100%; height: 100%">
                        <source :src="item.videoList.resource" type="video/mp4">
                        你的浏览器不支持Video标签
                    </video>
                </div>
                <div class="recommended" v-else>
                    <div class="title">
                        <span>推荐课程</span>
                        <p class="more" @click="handleJump(item.videoList[0])">更多 ></p>
                    </div>
                    <ul class="video-list">
                        <a v-for="video in item.videoList[1].children" :key="video.name" :href="video.url" target="_blank">
                            <img v-if="video.resource" :src="video.resource" alt="">
                            <img v-else src="../../images/online_env/bg.png" alt="">
                            <div class="identify">BlueKing</div>
                            <div class="name" :title="video.name">{{ video.name }}</div>
                            <div class="play"></div>
                            <span class="play-icon icon-player"></span>
                            <div class="shade"></div>
                            <div class="duration">{{video.extra_info.duration || '--'}}</div>
                        </a>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import bus from '@/js/bus.js'
export default {
    name: 'onlineEnv',
    data () {
        return {
            dataList: [],
            isplay: true
        }
    },
    created () {
        this.getOnlinePage()
    },
    methods: {
        getOnlinePage () {
            axios.get(myUrl + 'page/layer/online_exp/info/').then(res => {
                res.data.data.children.forEach(item => {
                    const config = {
                        name: item.name,
                        applicable: '',
                        desc: '',
                        process: [],
                        tags: [],
                        btns: [],
                        videoList: []
                    }
                    item.key = item.name === '功能体验环境' ? 'online' : 'env'
                    config.key = item.key
                    // 标签
                    item.children.forEach(ite => {
                        switch (ite.name) {
                            case '开发学习环境特色标签':
                                config.tags = ite.children.map(tag => tag.name)
                                break;
                            case '功能体验环境特色标签':
                                config.tags = ite.children.map(tag => tag.name)
                                break;
                            case '适用人群':
                                config.applicable = ite.desc
                                break;
                            case '环境描述':
                                config.desc = ite.desc
                                break;
                            case '申请流程':
                                config.process = ite.children.map((process, index) => {
                                    return {
                                        step: index + 1,
                                        name: process.name,
                                        hasNext: index + 1 !== ite.children.length,
                                        url: process.url
                                    }
                                })
                                break;
                            case 'button':
                                config.btns = ite.children.map(btn => btn)
                                break;
                            case '宣传video':
                                config.videoList = ite
                                break;
                            case '推荐课程':
                                config.videoList = ite.children.map(video => video)
                                break;
                        }
                    })
                    this.dataList.push(config)
                    
                })
            })
        },
        handlePlay () {
            this.isplay = false
            this.$nextTick(() => {
                const video = document.getElementById("video")
                video.controls = 'controls'
                video.play()
                const that = this
                video.addEventListener('ended', function () {
                    video.controls = false
                    video.load()
                    that.isplay = true
                })
            })
        },
        handleApply (item) {
            if (!item.url) return
            window.open(item.url, '_blank')
        },
        handleJump (item) {
            if (item.url) {
                this.$router.push({
                    path: item.url,
                    query: {
                        from: 'online'
                    }
                })
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    #online-env {
        color: #666871;
        .online {
            width: 100%;
            text-align: center;
            .online-container {
                width: 1120px;
                height: 100%;
                margin: 0 auto;
                padding-top: 89px;
                .title {
                    height: 56px;
                    font-family: PingFangSC-Medium;
                    font-weight: 500;
                    line-height: 56px;
                    font-size: 40px;
                    color: #313238;
                }
                .tag {
                    display: flex;
                    justify-content: center;
                    margin: 16px 0;
                    li {
                        width: 104px;
                        height: 32px;
                        line-height: 32px;
                        margin: 0 6px;
                        border-radius: 25px;
                        color: #666871;
                    }
                    .li-online {
                        background: #FFFFFF;
                    }
                    .li-env {
                        background: #F0F1F5;
                    }
                }
                .fit {
                    font-family: MicrosoftYaHei;
                    // font-weight: bold;
                    font-size: 12px;
                    color: #979BA5;
                    letter-spacing: 0;
                    line-height: 20px;
                    span {
                        font-size: 18px;
                        margin-right: 4px;
                        display: inline-block;
                    }
                }
                .message {
                    margin: 22px 0 32px;
                    font-family: PingFangSC-Regular;
                    font-weight: 400;
                    font-size: 16px;
                    color: #63656E;
                    text-align: center;
                    line-height: 28px;
                }
                .process-online {
                    background: #FFFFFF;
                }
                .process-env {
                    background: #F0F1F5;
                    .step {
                        .step-count {
                            background-color: #fff;
                        }
                    }
                }
                .process {
                    width: 990px;
                    height: 60px;
                    margin: 0 auto;
                    border-radius: 30px;
                    padding: 16px 38px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    box-shadow: 0 0 7px 0 rgba(0,0,0,0.04);
                    .step {
                        margin: 0 36px;
                        display: flex;
                        align-items: center;
                        .step-count {
                            height: 28px;
                            width: 28px;
                            line-height: 26px;
                            border-radius: 50%;
                            color: #979BA5;
                            border: 1px solid #979BA5;
                            margin-right: 12px;
                        }
                        .step-name {
                            font-family: PingFangSC-Regular;
                            font-weight: 400;
                            font-size: 14px;
                            color: #63656E;
                        }
                    }
                    .hasUrl {
                        cursor: pointer;
                        &:hover {
                            .step-count {
                                color: #3A84FF;
                                border: 1px solid #3A84FF;
                            }
                            .step-name {
                                color: #3A84FF;
                            }
                        }
                    }
                }
                .operate {
                    display: flex;
                    justify-content: center;
                    height: 48px;
                    margin: 40px auto;
                    .btn {
                        width: 180px;
                        font-size: 18px;
                        text-align: center;
                        line-height: 34px;
                        border: 1px solid #C4C6CC;
                        background-color: #fff;
                        border-radius: 24px;
                        color: #63656E;
                        margin: 0 12px;
                        font-weight: normal;
                    }
                    .online-env {
                        &:hover {
                            opacity: 0.8;
                        }
                    }
                    .online-btn {
                        background: #3A84FF;
                        border: none;
                        color: #fff;
                        &:hover {
                            background-color: #1768EF;
                        }
                    }
                }
                .video {
                    width: 1000px;
                    height: 562px;
                    margin: 0 auto;
                    padding: 24px;
                    background-color: #fff;
                    position: relative;
                    .shade {
                        position: absolute;
                        width: 952px;
                        height: 514px;
                        img {
                            width: 100%;
                            height: 100%;
                        }
                        p {
                            position: absolute;
                            font-family: TencentSansW7;
                            top: 134px;
                            left: 299px;
                            width: 368px;
                            height: 69px;
                            font-size: 46px;
                            color: #FFFFFF;
                        }
                        .tip2 {
                            display: block;
                            position: absolute;
                            top: 219px;
                            left: auto;
                            width: 100%;
                            height: 30px;
                            text-align: center;
                            font-family: TencentSansW3;
                            font-size: 20px;
                            color: #FFFFFF;
                            text-align: center;
                        }
                        .identify {
                            position: absolute;
                            width: 57px;
                            height: 16px;
                            top: 15px;
                            left: 19px;
                            font-family: PingFangSC-Regular;
                            font-weight: 400;
                            font-size: 12px;
                            color: #EAEBF0;
                        }
                        .play {
                            position: absolute;
                            top: 288px;
                            left: 365px;
                            width: 220px;
                            height: 70px;
                            border-radius: 45px;
                            font-size: 20px;
                            line-height: 70px;
                            color: #fff;
                            opacity: 0.6;
                            cursor: pointer;
                            z-index: 100;
                            &:hover {
                                background-color: #000000;
                                opacity: 0.9;
                            }
                        }
                        .play-desc {
                            position: absolute;
                            top: 288px;
                            left: 365px;
                            width: 220px;
                            height: 70px;
                            opacity: 0.6;
                            background: #000000;
                            box-shadow: 0 2px 21px 0 rgba(0,0,0,0.31);
                            border-radius: 45px;
                            z-index: 99;
                        }
                        .f-shade {
                            position: absolute;
                            left: 0;
                            bottom: 0;
                            width: 100%;
                            height: 70px;
                            text-align: left;
                            padding: 0 26px;
                            line-height: 70px;
                            font-size: 16px;
                            color: #fff;
                            cursor: pointer;
                            z-index: 100;
                        }
                        .f-shade-desc {
                            position: absolute;
                            left: 0;
                            bottom: 0;
                            width: 100%;
                            height: 70px;
                            opacity: 0.5;
                            background: #000000;
                            z-index: 99;
                        }
                    }
                }
                .recommended {
                    width: 1200px;
                    height: 278px;
                    margin-left: -40px;
                    .title {
                        display: flex;
                        justify-content: space-between;
                        font-size: 24px;
                        font-weight: 500;
                        .more {
                            font-weight: 400;
                            font-size: 14px;
                            color: #63656E;
                            cursor: pointer;
                            &:hover {
                                color: #3A84FF;
                            }
                        }
                    }
                    .video-list {
                        display: flex;
                        justify-content: space-between;
                        a {
                            width: 388px;
                            height: 219px;
                            background-color: #979BA5;
                            cursor: pointer;
                            position: relative;
                            img {
                                width: 100%;
                                height: 100%;
                            }
                            .identify {
                                position: absolute;
                                width: 50px;
                                height: 17px;
                                top: 8px;
                                left: 12px;
                                font-family: PingFangSC-Regular;
                                font-weight: 400;
                                font-size: 12px;
                                color: #EAEBF0;
                            }
                            .name {
                                position: absolute;
                                font-family: TencentSansW7;
                                top: 85px;
                                left: 0;
                                width: 100%;
                                padding: 0 40px;
                                height: 33px;
                                font-size: 22px;
                                color: #FFFFFF;
                                text-align: center;
                            }
                            .play {
                                display: none;
                                position: absolute;
                                top: 70px;
                                left: 155px;
                                width: 80px;
                                height: 80px;
                                border-radius: 50%;
                                opacity: 0.5;
                                background: #000000;
                            }
                            .play-icon {
                                display: none;
                                position: absolute;
                                top: 96px;
                                left: 182px;
                                font-size: 28px;
                                color: #fff;
                                z-index: 100;
                            }
                            .shade {
                                position: absolute;
                                top: 0;
                                left: 0;
                                z-index: 99;
                            }
                            .duration {
                                position: absolute;
                                bottom: 9px;
                                right: 10px;
                                padding: 2px 3px 2px 23px;
                                background: #39384f;
                                border-radius: 2px;
                                opacity: .8;
                                font-size: 12px;
                                font-weight: 500;
                                line-height: 18px;
                                color: #fff;
                                &::after {
                                    position: absolute;
                                    bottom: 6px;
                                    left: 8px;
                                    content: "";
                                    display: block;
                                    border-left: 7px solid #fff;
                                    border-top: 5px solid transparent;
                                    border-bottom: 5px solid transparent;
                                }
                            }
                            &:hover {
                                .desc {
                                    opacity: 0.4;
                                }
                                .shade {
                                    width: 100%;
                                    height: 100%;
                                    opacity: 0.4;
                                    background: #000000;
                                }
                                .play {
                                    display: block;
                                }
                                .play-icon {
                                    display: block;
                                }
                            }
                        }
                    }
                }
            }
        }
        .online-bg {
            background: url('../../images/online_env/bg-01.png') no-repeat;
            background-size: 100% 100%;
            height: 1150px;
            margin-top: 60px;
        }
        .env-bg {
            background: url('../../images/online_env/bg-02.png') no-repeat;
            background-size: 100% 100%;
            height: 919px;
        }
    }
</style>


// WEBPACK FOOTER //
// index.vue?f63d2ffe